import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { toggleSidebar } from '../../store/actions/layout';
import { errorMessage } from '../../utils/message';

const Main = () => {
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const { isSidebarOpened } = useSelector((state) => state.layout);
   const { isAuthenticated } = useSelector((state) => state.auth);

   const [trackNum, setTrackNum] = useState('');
   const sliderChange = useRef();

   useEffect(() => {
      window.scrollTo(0, 0);

      const sliderLength = sliderChange.current.children.length - 1;
      const slidesArry = Array.prototype.slice.call(sliderChange.current.children);
      const slides = slidesArry.slice(0, 4);
      let counter = 0;
      const interval = setInterval(() => {
         counter = counter === sliderLength - 1 ? 0 : counter + 1;
         slides.forEach((item) => {
            if (item.classList.contains('active')) {
               item.classList.remove('active');
            }
         });
         slides[counter].classList.add('active');
      }, 14000);

      return () => {
         clearInterval(interval);
      };
   }, []);

   return (
      <>
         <main className='main' onClick={() => isSidebarOpened && dispatch(toggleSidebar())}>
            <section className='main__container'>
               <div ref={sliderChange} className='slider'>
                  <div className='slider__item slider__item--four-parts active'>
                     <div className='slider__item-bg'>
                        <div className='slider__part slider__part--top-left'></div>
                        <div className='slider__part slider__part--top-right'></div>
                        <div className='slider__part slider__part--bot-left'></div>
                        <div className='slider__part slider__part--bot-right'></div>
                     </div>
                     <div className='slider__item-content'></div>
                  </div>
                  <div className='slider__item slider__item--nine-parts'>
                     <div className='slider__item-bg'>
                        <div className='slider__part slider__part--left-top'></div>
                        <div className='slider__part slider__part--mid-top'></div>
                        <div className='slider__part slider__part--right-top'></div>
                        <div className='slider__part slider__part--left-mid'></div>
                        <div className='slider__part slider__part--mid-mid'></div>
                        <div className='slider__part slider__part--right-mid'></div>
                        <div className='slider__part slider__part--left-bot'></div>
                        <div className='slider__part slider__part--mid-bot'></div>
                        <div className='slider__part slider__part--right-bot'></div>
                     </div>
                     <div className='slider__item-content'></div>
                  </div>
                  <div className='slider__item slider__item--five-parts'>
                     <div className='slider__item-bg'>
                        <div className='slider__part slider__part-one'></div>
                        <div className='slider__part slider__part-two'></div>
                        <div className='slider__part slider__part-three'></div>
                        <div className='slider__part slider__part-four'></div>
                        <div className='slider__part slider__part-five'></div>
                     </div>
                     <div className='slider__item-content'></div>
                  </div>
                  <div className='slider__item slider__item--three-parts'>
                     <div className='slider__item-bg'>
                        <div className='slider__part slider__part-left'></div>
                        <div className='slider__part slider__part-mid'></div>
                        <div className='slider__part slider__part-right'></div>
                     </div>
                     <div className='slider__item-content'></div>
                  </div>
                  <div className='slider__control right'>
                     <label
                        className='page-0-right'
                        id='controlerLables'
                        htmlFor='page-one'
                     ></label>
                     <label
                        className='page-1-right'
                        id='controlerLables'
                        htmlFor='page-two'
                     ></label>
                     <label
                        className='page-2-right'
                        id='controlerLables'
                        htmlFor='page-three'
                     ></label>
                     <label
                        className='page-3-right'
                        id='controlerLables'
                        htmlFor='page-four'
                     ></label>
                  </div>
               </div>
            </section>

            <form
               className='tracking'
               onSubmit={(e) => {
                  e.preventDefault();
                  if (trackNum.toString().trim()) {
                     navigate(`/tracking/${trackNum}`);
                  } else {
                     errorMessage('لطفا کد رهگیری را وارد نمایید');
                  }
               }}
            >
               <input
                  type='text'
                  className='tracking__input'
                  name=''
                  placeholder='کد رهگیری'
                  value={trackNum}
                  onChange={(e) => setTrackNum(e.target.value)}
               />
               <button type='submit' className='btn btn--Primary'>
                  رهگیری
               </button>
            </form>

            <section className='order'>
               <Link to='/order' className='order__item'>
                  <img src='/img/box-seam-svgrepo-com.svg' alt='send package' />
                  <h4>ارسال بسته</h4>
               </Link>
               <Link to='/store' className='order__item'>
                  <img src='/img/store-svgrepo-com.svg' alt='shop' />
                  <h4>ثبت فروشگاه</h4>
               </Link>
               <Link to='/agent' className='order__item'>
                  <img src='/img/two-men-standing-svgrepo-com.svg' alt='agents' />
                  <h4>نمایندگی ها</h4>
               </Link>
               <Link to='/tracking' className='order__item'>
                  <img src='/img/eye-tracking-svgrepo-com.svg' alt='tracking' />
                  <h4>رهگیری</h4>
               </Link>
               <Link to='/estimate-price' className='order__item'>
                  <img src='/img/money.svg' alt='price estimation' />
                  <h4>برآورد قیمت</h4>
               </Link>
               <Link to='/estimate-time' className='order__item'>
                  <img src='/img/time-svgrepo-com.svg' alt='time estimation' />
                  <h4>برآورد زمان</h4>
               </Link>
            </section>

            <section className='kards'>
               <div className='kards__wrapper'>
                  <div className='kards__card kards__card-index'>
                     <img src='/img/image1.jpg' className='kards__card-img' />
                     <span>درگاه سفارش آنلاین</span>
                  </div>

                  <div className='kards__card kards__card-index'>
                     <img src='/img/image2.jpg' className='kards__card-img' />
                     <span>امور مشتریان</span>
                  </div>

                  <Link to='/aboutUs' className='kards__card kards__card-index'>
                     <img src='/img/image3.jpg' className='kards__card-img' />
                     <span>ارتباط با کالا پست</span>
                  </Link>

                  <Link to='/agent' className='kards__card kards__card-index'>
                     <img src='/img/image4.jpg' className='kards__card-img' />
                     <span>نمایندگان کالاپست</span>
                  </Link>

                  <div className='kards__card kards__card-index'>
                     <img src='/img/image5.jpg' className='kards__card-img' />
                     <span>درخواست نمایندگی</span>
                  </div>
               </div>
            </section>

            <section className='services'>
               <h2 className='services__heading'>خدمات کالاپست</h2>
               <div className='services__content'>
                  <Link
                     className='services__content-item'
                     id='item-one'
                     to={'/services#special-post'}
                  >
                     <img className='services__content-img' src='/img/post.png' />
                     <h4>پست ویژه</h4>
                  </Link>
                  <Link className='services__content-item' id='item-two' to={'/services#in-place'}>
                     <img className='services__content-img' src='/img/money.png' />
                     <h4>پرداخت در محل</h4>
                  </Link>
                  <Link className='services__content-item' id='item-three' to='/services#inventory'>
                     <img className='services__content-img' src='/img/inventory.png' />
                     <h4>انبارداری</h4>
                  </Link>
                  <Link className='services__content-item' id='item-four' to='/services#packing'>
                     <img className='services__content-img' src='/img/post (2).png' />
                     <h4>بسته بندی</h4>
                  </Link>
                  <img
                     className='services__content-imgcenter'
                     id='img-center'
                     src='/img/img-center.png'
                     alt=''
                  />
                  <Link
                     className='services__content-item'
                     id='item-five'
                     to='/services#international-post'
                  >
                     <img className='services__content-img' src='/img/international.png' />
                     <h4>پست بین الملل</h4>
                  </Link>
                  <Link className='services__content-item' id='item-six' to='/services#IR-post'>
                     <img className='services__content-img' src='/img/iran.png' />
                     <h4>پست جمهوری اسلامی</h4>
                  </Link>
                  <Link className='services__content-item' id='item-seven' to='/services#in-town'>
                     <img className='services__content-img' src='/img/city.png' />
                     <h4>ارسال درون شهری</h4>
                  </Link>
                  <Link className='services__content-item' id='item-eight' to='/services#insurance'>
                     <img className='services__content-img' src='/img/insurance.png' />
                     <h4>بیمه مرسولات</h4>
                  </Link>
               </div>
            </section>

            <Link to='/order' className='main__Send-package'>
               <img className='main__Send-package-img' src='/img/postfix.png' />
               <h4>ارسال بسته</h4>
            </Link>
         </main>
      </>
   );
};

export default Main;
